class DetailSelect {
  constructor(container) {
    this.container = container;
    this.options = container.querySelectorAll('.we-select > .we-select__item');
    const checked = container.querySelector('input:checked');
    this.value = checked ? checked.value : null;
    this.mouseDown = false;
    this._addEventListeners();
    this._setAria();
    if (checked) this.applySelection(checked, false);
  }

  applySelection(input, dispatchChange) {
    if (!input) return;

    const summary = this.container.querySelector('.we-select-container__summary');
    const summaryMain = summary?.querySelector('.we-select-container__summary-main');
    const label = input.parentNode?.querySelector('label');
    const pos = [...this.options].indexOf(input.parentNode) + 1;

    if (summaryMain && label) {
      summaryMain.innerHTML = label.innerHTML;
    } else if (summary && label) {
      summary.innerHTML = label.innerHTML;
    }

    if (summary) {
      summary.setAttribute('aria-label', `${input.value}, listbox ${pos} of ${this.options.length}`);
    }
    this.value = input.value;

    this.options.forEach((opt) => {
      opt.classList.remove('active');
      opt.setAttribute('aria-selected', 'false');
    });
    input.parentNode.classList.add('active');
    input.parentNode.setAttribute('aria-selected', 'true');

    if (dispatchChange) {
      input.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
    }
  }

  _addEventListeners() {
    const listbox = this.container.querySelector('.we-select');
    this.scrolled = false;

    listbox?.addEventListener(
      'scroll',
      () => {
        this.scrolled = true;
      },
      { passive: true }
    );

    this.container.addEventListener('change', (e) => {
      if (e.target?.matches?.('input[type="radio"]')) {
        this.applySelection(e.target, false);
      }
    });

    this.container.addEventListener('toggle', () => {
      if (this.container.open) return;
      const checked = this.container.querySelector('input:checked');
      if (checked) this.applySelection(checked, false);
    });

    this.container.addEventListener('focusout', () => {
      if (this.mouseDown) return;
      this.container.removeAttribute('open');
    });

    this.options.forEach((opt) => {
      opt.addEventListener('mousedown', () => {
        this.mouseDown = true;
        this.scrolled = false;
      });
      opt.addEventListener('mouseup', () => {
        this.mouseDown = false;
        // Keep open after a scroll gesture so mobile users can pick an option
        if (!this.scrolled) {
          this.container.removeAttribute('open');
        }
      });
    });

    this.container.addEventListener('keyup', (e) => {
      const keycode = e.which;
      const checkedInput = this.container.querySelector('.we-select input:checked');
      const current = checkedInput ? [...this.options].indexOf(checkedInput.closest('.we-select__item')) : 0;
      switch (keycode) {
        case 27:
          this.container.removeAttribute('open');
          break;
        case 35:
          e.preventDefault();
          if (!this.container.open) this.container.setAttribute('open', '');
          this.setChecked(this.options[this.options.length - 1].querySelector('input'));
          break;
        case 36:
          e.preventDefault();
          if (!this.container.open) this.container.setAttribute('open', '');
          this.setChecked(this.options[0].querySelector('input'));
          break;
        case 38:
          e.preventDefault();
          if (!this.container.open) this.container.setAttribute('open', '');
          this.setChecked(this.options[current > 0 ? current - 1 : 0].querySelector('input'));
          break;
        case 40:
          e.preventDefault();
          if (!this.container.open) this.container.setAttribute('open', '');
          this.setChecked(
            this.options[current < this.options.length - 1 ? current + 1 : this.options.length - 1].querySelector(
              'input'
            )
          );
          break;
      }
    });
  }

  _setAria() {
    this.container.setAttribute('aria-haspopup', 'listbox');
    const listbox = this.container.querySelector('.we-select');
    if (listbox) listbox.setAttribute('role', 'listbox');
    const summary = this.container.querySelector('.we-select-container__summary');
    summary.setAttribute('aria-label', 'unselected listbox');
    summary.setAttribute('aria-live', 'polite');
    this.options.forEach((opt) => {
      opt.setAttribute('role', 'option');
    });
  }

  setChecked(input) {
    if (!input || input.disabled) return;
    input.checked = true;
    this.applySelection(input, true);
  }
}

function initWeDetailsSelects(root = document) {
  root.querySelectorAll('details.we-select-container:not([data-we-details-init])').forEach((el) => {
    try {
      new DetailSelect(el);
      el.setAttribute('data-we-details-init', '');
    } catch (err) {
      console.warn('[we-details-select]', err);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => initWeDetailsSelects());
document.addEventListener('product-info:loaded', () => initWeDetailsSelects());
document.addEventListener('shopify:section:load', (e) => initWeDetailsSelects(e.target));
